"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const modal_style_1 = require("../../components/modal/modal.style");
const theme_1 = require("../../components/theme");
const theme_palette_1 = require("../../components/theme.palette");
exports.CSS = {
    container: 'c-DownloadManager',
    popover: 'c-DownloadManager__popover',
    popoverClosing: 'c-DownloadManager__popover--closing',
    header: 'c-DownloadManager__header',
    title: 'c-DownloadManager__title',
    table: 'c-DownloadManager__table',
    row: 'c-DownloadManager__row',
    rowClickable: 'c-DownloadManager__row--clickable',
    cellType: 'c-DownloadManager__cell--type',
    cellJob: 'c-DownloadManager__cell--job',
    cellStatus: 'c-DownloadManager__cell--status',
    cellAction: 'c-DownloadManager__cell--action',
    cellIndicator: 'c-DownloadManager__cell--indicator',
    unseenDot: 'c-DownloadManager__unseen-dot',
    unseenDotComplete: 'c-DownloadManager__unseen-dot--complete',
    unseenDotWarning: 'c-DownloadManager__unseen-dot--warning',
    unseenDotError: 'c-DownloadManager__unseen-dot--error',
    statusProcessing: 'c-DownloadManager__status--processing',
    statusComplete: 'c-DownloadManager__status--complete',
    statusDownloaded: 'c-DownloadManager__status--downloaded',
    statusWarning: 'c-DownloadManager__status--warning',
    statusError: 'c-DownloadManager__status--error',
    actionIcon: 'c-DownloadManager__action-icon',
    actionWarning: 'c-DownloadManager__action-icon--warning',
    actionError: 'c-DownloadManager__action-icon--error',
    badge: 'c-DownloadManager__badge',
    redDot: 'c-DownloadManager__red-dot',
    clearButton: 'c-DownloadManager__clear-button',
    empty: 'c-DownloadManager__empty',
    pulse: 'c-DownloadManager--pulse',
};
exports.Style = {
    [exports.CSS.container]: {
        position: 'relative',
        display: 'inline-block',
    },
    [exports.CSS.popover]: {
        position: 'absolute',
        top: theme_1.DefaultTheme.space(1),
        right: theme_1.DefaultTheme.space(1),
        'min-width': '480px',
        padding: `${theme_1.DefaultTheme.space(1)} 0`,
        'z-index': modal_style_1.MODAL_Z_INDEX - 1,
        color: theme_1.DefaultTheme.font.color.supporting,
        'background-color': theme_1.DefaultTheme.background.offWhite,
        display: 'flex',
        'flex-direction': 'column',
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp4,
        opacity: 1,
        transition: 'opacity .15s ease-in-out',
    },
    [exports.CSS.popoverClosing]: {
        opacity: 0,
    },
    [exports.CSS.header]: {
        padding: `${theme_1.DefaultTheme.space(2)} ${theme_1.DefaultTheme.space(3)}`,
        'border-bottom': `1px solid ${theme_1.DefaultTheme.font.color.divider}`,
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'space-between',
    },
    [exports.CSS.title]: {
        'font-weight': theme_1.DefaultTheme.font.weight.bold,
        color: theme_1.DefaultTheme.font.color.primary,
    },
    [exports.CSS.table]: {
        display: 'flex',
        'flex-direction': 'column',
        'max-height': '320px',
        'overflow-y': 'auto',
    },
    [exports.CSS.row]: {
        color: theme_1.DefaultTheme.font.color.supporting,
        'font-family': theme_1.DefaultTheme.font.family,
        'font-size': theme_1.DefaultTheme.font.size,
        'line-height': theme_1.DefaultTheme.space(8),
        display: 'flex',
        'align-items': 'center',
        padding: `${theme_1.DefaultTheme.space(2)} ${theme_1.DefaultTheme.space(3)}`,
        transition: 'background-color .12s ease',
        '&:hover': {
            'background-color': theme_1.DefaultTheme.background.lightGrey,
        },
    },
    [exports.CSS.rowClickable]: {
        cursor: 'pointer',
    },
    [exports.CSS.cellIndicator]: {
        width: '20px',
        'flex-shrink': 0,
        display: 'flex',
        'align-items': 'center',
    },
    [exports.CSS.cellType]: {
        width: '80px',
        color: theme_1.DefaultTheme.font.color.supporting,
        'flex-shrink': 0,
        'white-space': 'nowrap',
        overflow: 'hidden',
        'text-overflow': 'ellipsis',
        'padding-right': theme_1.DefaultTheme.space(2),
    },
    [exports.CSS.cellJob]: {
        flex: 1,
        color: theme_1.DefaultTheme.font.color.primary,
        overflow: 'hidden',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap',
        'padding-right': theme_1.DefaultTheme.space(2),
    },
    [exports.CSS.cellStatus]: {
        width: '80px',
        'flex-shrink': 0,
        'text-align': 'right',
        'font-size': '12px',
        'padding-right': theme_1.DefaultTheme.space(1),
    },
    [exports.CSS.cellAction]: {
        width: '36px',
        'flex-shrink': 0,
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
    },
    [exports.CSS.unseenDot]: {
        width: '8px',
        height: '8px',
        'border-radius': '50%',
    },
    [exports.CSS.unseenDotComplete]: {
        background: theme_palette_1.ColorPalette2022Branding.darkGreen,
    },
    [exports.CSS.unseenDotWarning]: {
        background: theme_palette_1.ColorPalette2022Branding.ikeOrange,
    },
    [exports.CSS.unseenDotError]: {
        background: theme_palette_1.ColorPalette2022Branding.lightRed,
    },
    [exports.CSS.statusProcessing]: {
        color: theme_1.DefaultTheme.font.color.supporting,
    },
    [exports.CSS.statusComplete]: {
        color: theme_palette_1.ColorPalette2022Branding.darkGreen,
    },
    [exports.CSS.statusDownloaded]: {
        color: theme_palette_1.ColorPalette2022Branding.darkGreen,
        opacity: 0.6,
    },
    [exports.CSS.statusWarning]: {
        color: theme_palette_1.ColorPalette2022Branding.ikeOrange,
    },
    [exports.CSS.statusError]: {
        color: theme_palette_1.ColorPalette2022Branding.lightRed,
    },
    [exports.CSS.actionIcon]: {
        color: 'rgba(0,0,0,0.54)',
        'font-size': '20px',
    },
    [exports.CSS.actionWarning]: {
        color: theme_palette_1.ColorPalette2022Branding.ikeOrange,
    },
    [exports.CSS.actionError]: {
        color: theme_palette_1.ColorPalette2022Branding.lightRed,
    },
    [exports.CSS.badge]: {
        position: 'absolute',
        top: '2px',
        right: '2px',
        background: theme_palette_1.ColorPalette2022Branding.lightRed,
        color: 'white',
        'border-radius': '50%',
        width: '16px',
        height: '16px',
        'font-size': '10px',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        'pointer-events': 'none',
    },
    [exports.CSS.redDot]: {
        position: 'absolute',
        top: '4px',
        right: '4px',
        background: theme_palette_1.ColorPalette2022Branding.lightRed,
        'border-radius': '50%',
        width: '8px',
        height: '8px',
        'pointer-events': 'none',
    },
    [exports.CSS.clearButton]: {
        background: 'none',
        border: 'none',
        color: theme_1.DefaultTheme.font.color.supporting,
        cursor: 'pointer',
        'font-size': theme_1.DefaultTheme.font.size,
        'font-family': theme_1.DefaultTheme.font.family,
        padding: `${theme_1.DefaultTheme.space(1)} ${theme_1.DefaultTheme.space(2)}`,
        'border-radius': '4px',
        transition: 'background-color .12s ease, color .12s ease',
        '&:hover:not(:disabled)': {
            'background-color': theme_1.DefaultTheme.background.lightGrey,
            color: theme_1.DefaultTheme.font.color.primary,
        },
        '&:disabled': {
            opacity: 0.4,
            cursor: 'default',
        },
    },
    [exports.CSS.empty]: {
        padding: `${theme_1.DefaultTheme.space(4)} ${theme_1.DefaultTheme.space(3)}`,
        color: theme_1.DefaultTheme.font.color.disabled,
        'text-align': 'center',
    },
    '@keyframes dm-pulse': {
        '0%': { 'box-shadow': '0 0 0 0 rgba(255, 146, 57, 0.8)', transform: 'scale(1)' },
        '50%': { 'box-shadow': '0 0 12px 8px rgba(255, 146, 57, 0.6)', transform: 'scale(1.1)' },
        '100%': { 'box-shadow': '0 0 0 0 rgba(255, 146, 57, 0)', transform: 'scale(1)' },
    },
    [exports.CSS.pulse]: {
        animation: 'dm-pulse 1.5s ease-in-out infinite',
        'border-radius': '50%',
    },
};
//# sourceMappingURL=download.manager.style.js.map